"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LayoutReader = /** @class */ (function () {
    function LayoutReader(key, properties, controlResolver, _context, predecessor) {
        this.key = key;
        this.properties = properties;
        this.controlResolver = controlResolver;
        this._context = _context;
        this.predecessor = predecessor;
    }
    Object.defineProperty(LayoutReader.prototype, "context", {
        get: function () {
            return this._context;
        },
        enumerable: true,
        configurable: true
    });
    LayoutReader.prototype.read = function (key, value) {
        if (this.isCapableToParse(key, value)) {
            return this.readValue(value);
        }
        else {
            return this.predecessor ? this.predecessor.read(key, value) : value;
        }
    };
    LayoutReader.prototype.isCapableToParse = function (key, value) {
        return key === this.key;
    };
    return LayoutReader;
}());
exports.LayoutReader = LayoutReader;
//# sourceMappingURL=layout-reader.js.map